/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedCalculatorListPublic } from './PaginatedCalculatorListPublic'
import {
  PaginatedCalculatorListPublicFromJSON,
  PaginatedCalculatorListPublicFromJSONTyped,
  PaginatedCalculatorListPublicToJSON,
} from './PaginatedCalculatorListPublic'

/**
 *
 * @export
 * @interface EnvelopedCalculatorListCalculatorListPublic
 */
export interface EnvelopedCalculatorListCalculatorListPublic {
  /**
   *
   * @type {PaginatedCalculatorListPublic}
   * @memberof EnvelopedCalculatorListCalculatorListPublic
   */
  body: PaginatedCalculatorListPublic
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCalculatorListCalculatorListPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCalculatorListCalculatorListPublic interface.
 */
export function instanceOfEnvelopedCalculatorListCalculatorListPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCalculatorListCalculatorListPublicFromJSON(
  json: any,
): EnvelopedCalculatorListCalculatorListPublic {
  return EnvelopedCalculatorListCalculatorListPublicFromJSONTyped(json, false)
}

export function EnvelopedCalculatorListCalculatorListPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCalculatorListCalculatorListPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedCalculatorListPublicFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCalculatorListCalculatorListPublicToJSON(
  value?: EnvelopedCalculatorListCalculatorListPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedCalculatorListPublicToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
